<template>
    <div class="footer">
        <div class="foot_div">
              <div class="foot_top">
                  <img class="footimg1" src="./../static/images/fi1.png" alt="">
                  <img class="footimg2" src="./../static/images/fi2.png" alt="">
              </div>
              <div class="foot_bottom">
                   <div class="foot_div1">
                        <!-- <a href="">联盟学校</a> -->
                        <router-link to="/intro?id=1"  href="">联盟简介</router-link>
                        <router-link to="/intro?id=2" style="margin:20px 0"  href="">联系我们</router-link>
                   </div>
                   <div class="foot_div2">
                       <p>主办单位：杭州市教育局</p>
                       <p style="margin-top:20px">技术支持：杭州网</p>
                   </div>
                   <div>
                    <p> 杭州网(杭州网络传媒有限公司)版权所有</p>
                    <p  style="margin:20px 0">  未经授权禁止复制或镜像</p>
                    <p>   工信部备案号:浙ICP备11041366号-1</p>
                   </div>
              </div>
        </div>
   </div>
</template>
<script>
export default {
    name:'footComponent',
    data(){
      return {
       
      }
    },
    created(){
   
    }
}
</script>
<style scoped>
.footer{
    width: 100%;
    height: 410px;
    background-color: #171e3f;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: start;
  }
  .foot_div{
    width: 1400px;
  }
  .foot_top{
    width: 100%;
    height: 126px;
    border-bottom:2px solid #3c468b;
  }
  .footimg1{
    width: 150px;
    height: 40px;
    margin-top: 35px;
  }
  .footimg2{
    width: 217px;
    height: 46px;
    margin-left: 40px;
    margin-top: 25px;
  }
  .foot_bottom{
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: start;
    margin-top: 40px;
  }
  .foot_bottom p{
    margin: 0 ;
    padding: 0;
    color: #6275d3;
  }
  .foot_div1{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
  .foot_div1 a{
    text-decoration: none;
    color: #6275d3;
  }
  .foot_div2{
     margin: 0 110px 0 120px;
  }
</style>
